import { httpClient } from "../http/httpClient";

export interface SelectOfferPayload {
  produtoId: number;
  convenioId: number;
  tabelaJurosId: number;
  renda: number;
  valor: number;
  tipoCalculo: 0 | 1;
}

export async function selectOffer(id: string, payload: SelectOfferPayload) {
  const { data } = await httpClient.patch(`/crefaz/${id}/selectOffer`, payload);
  return data;
}
